module.exports = __webpack_public_path__ + "static/media/snoopyrainy02.dea69306.gif";